// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__jRnlg","rootSmall":"AddTileButton_rootSmall__Av-z2"};